import {
  Backdrop,
  Box,
  Grid,
  Menu,
  MenuItem,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from "@mui/material"
import { useHistory } from "react-router-dom"
import Header from "components/Header/Header"
import ProfileDisplayer from "components/ProfileDisplayer"
import AppPagination from "components/StyledComponents/AppPagination"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getNotableVipsAction,
  // approveVipAction,
  deleteNotableVipAction,
  secondApproveVipAction,
  getDynamicMenuFieldsAction,
  approveVipAction
} from "redux/superAdmin/actions"
import { marketingActions } from "redux/marketing/slice/user"
import { getFoodItemsAction } from "redux/marketing/actions"
import { vipConfigurationColumns } from "helpers/constant"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import SearchComponent from "components/SearchComponent"
import { useDebounce } from "hooks/utils"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import moment from "moment"
import { appActions } from "redux/app/slice/app"
import AddMenuItems from "pages/private/marketing/menu/AddMenuItems"

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: "12px 24px"
}))

const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "12px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: "none",
    boxSizing: "border-box",
    "&:last-child": {
      paddingRight: 0
    }
  },
  "& .MuiTableRow-root": {
    borderBottom: `2px solid ${theme.palette.drawer.main}`,
    "&:last-child": {
      borderBottom: "none"
    }
  },
  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "sticky",
    borderBottom: `2px solid ${theme.palette.drawer.main}`,
    "&:last-child": {
      paddingRight: 0
    }
  }
}))

const VipConfiguration = () => {
  const [breadCrumbs, setBreadCrumbs] = useState([])
  const [selectedVip, setSelectedVip] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [deleteModal, setDeleteModal] = useState(false)
  const [openMenuItemsModal, setOpenMenuItemsModal] = useState(false)
  const dispatch = useDispatch()
  const { notableVips } = useSelector((store) => store?.superAdmin)
  const { isLoading } = useSelector((store) => store?.app)
  const { startDate, endDate, searchField } = useSelector((store) => store?.app?.filters || "")
  const { menuSubCategory, foodItem } = useSelector((store) => store?.marketing?.menu)
  const theme = useTheme()
  const history = useHistory()
  const openMenu = Boolean(anchorEl)
  const debouncedSearchTerm = useDebounce(searchField, 500)

  useEffect(() => {
    document.title = "VIP Configuration"
    setBreadCrumbs(createBreadcrumbs())
    dispatch(
      appActions.initFilters({
        startDate: moment().format("YYYY-MM-DD")
      })
    )
  }, [])

  useEffect(() => {
    if (openMenuItemsModal && foodItem?.category) {
      const categoryId = foodItem.category?.id ?? foodItem.category
      dispatch(marketingActions.setMenuCategoryId(categoryId))
    }
  }, [foodItem, openMenuItemsModal])

  useEffect(() => {
    setCurrentPage(1)
    let computedStartDate = startDate
    let computedEndDate = endDate
    if (!startDate) {
      computedStartDate = moment().format("YYYY-MM-DD")
    }
    if (!endDate) {
      computedEndDate = moment().format("YYYY-MM-DD")
    }
    dispatch(getNotableVipsAction({ startDate: computedStartDate, endDate: computedEndDate }))
  }, [startDate, endDate, debouncedSearchTerm])

  const handleAddVip = () => {
    const itemsLink = {
      item: "vip",
      category: menuSubCategory?.[0]?.name,
      list: "detailed view"
    }
    dispatch(marketingActions.setMenuLink(itemsLink))
    history.push("/marketing/dashboard/explore-menu/edit")
  }

  const getApprovalStatusColor = (approvalStatus) => {
    return approvalStatus ? theme.palette.success?.main : theme.palette.error?.main
  }

  const handleApproveVip = (vip) => {
    let computedStartDate = startDate
    let computedEndDate = endDate
    if (!startDate) {
      computedStartDate = moment().format("YYYY-MM-DD")
    }
    if (!endDate) {
      computedEndDate = moment().format("YYYY-MM-DD")
    }
    dispatch(
      secondApproveVipAction({
        id: vip?.id,
        is_second_approved: true,
        startDate: computedStartDate,
        endDate: computedEndDate
      })
    )
    handleMenuClose()
  }

  const handleApproveVipCMS = (vip) => {
    let computedStartDate = startDate
    let computedEndDate = endDate
    if (!startDate) {
      computedStartDate = moment().format("YYYY-MM-DD")
    }
    if (!endDate) {
      computedEndDate = moment().format("YYYY-MM-DD")
    }
    dispatch(
      approveVipAction({
        id: vip?.id,
        startDate: computedStartDate,
        endDate: computedEndDate
      })
    )
    handleMenuClose()
  }
  // const handleEditVip = () => {
  //   const itemsLink = {
  //     item: "vip",
  //     category: menuSubCategory?.[0]?.name,
  //     list: "detailed view"
  //   }
  //   dispatch(marketingActions.setMenuLink(itemsLink))
  //   history.push("/marketing/dashboard/explore-menu/edit")
  //   handleMenuClose()
  // }

  const handleDeleteVip = () => {
    setDeleteModal(true)
    handleMenuClose()
  }

  const onConfirmDelete = () => {
    dispatch(deleteNotableVipAction({ id: selectedVip?.id }))
    setDeleteModal(false)
  }

  const handleMenuClick = (event, vip) => {
    setAnchorEl(event.currentTarget)
    setSelectedVip(vip)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleViewVip = (row) => {
    dispatch(marketingActions.setFoodItemsDetail({}))
    dispatch(marketingActions.setMenuCategoryId(""))
    dispatch(getDynamicMenuFieldsAction({ category: "Vip" }))
    dispatch(
      marketingActions.setMenuLink({
        item: "vip",
        category: menuSubCategory?.[0]?.name,
        list: "detailed view"
      })
    )
    dispatch(marketingActions.setMenuItemId(row?.id))
    dispatch(getFoodItemsAction())
    setSelectedVip(row)
    setOpenMenuItemsModal(true)
  }

  const itemsPerPage = 12
  const filteredVipsList =
    notableVips?.data?.filter((vip) => {
      const term = debouncedSearchTerm?.toLowerCase()
      return vip?.name?.toLowerCase().includes(term) || vip?.email?.toLowerCase().includes(term)
    }) ?? []
  const totalPages = Math.ceil(filteredVipsList?.length / itemsPerPage)

  const paginatedNotableVipsList = filteredVipsList?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  )

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Header title="VIP Configuration" breadCrumbs={breadCrumbs}>
          <Box sx={{ marginRight: "20px" }}>
            <SearchComponent />
          </Box>
          <AppButton onClick={handleAddVip} styles={{ padding: "14px 30px" }}>
            Add VIP
          </AppButton>
        </Header>
      </Grid>
      <Grid item xs={12}>
        <TableContainer sx={{ maxHeight: 700 }}>
          <CustomTable>
            <TableHead>
              <TableRow>
                {vipConfigurationColumns?.map((column) => (
                  <TableCell
                    key={column.id}
                    sx={{ minWidth: column.minWidth }}
                    align={column.align}>
                    <Typography variant="body2Regular" color={theme.palette.text.secondary}>
                      {column.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedNotableVipsList?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={vipConfigurationColumns?.length} align="center">
                    {isLoading ? "Please wait we are getting the vips..." : "No Data Available"}
                  </TableCell>
                </TableRow>
              ) : (
                paginatedNotableVipsList?.map((row, index) => (
                  <TableRow key={row.id || index}>
                    <TableCell align="center">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="center">
                      <Box className="d-flex align-items-center gap-1">
                        <ProfileDisplayer image={row?.image_url} />
                        <Typography variant="body1Regular">{row?.name ?? "-"}</Typography>
                        <VisibilityOutlinedIcon
                          sx={{ cursor: "pointer", fontSize: "18px", ml: 1 }}
                          onClick={() => handleViewVip(row)}
                        />
                      </Box>
                    </TableCell>
                    <TableCell align="center">{row?.category ?? "-"}</TableCell>
                    <TableCell align="center">{row?.arriving_time ?? "-"}</TableCell>
                    <TableCell align="center">
                      {row?.arriving_day
                        ? moment(new Date(row.arriving_day)).format("MMM DD, YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell align="center">
                      <Typography
                        variant="body2Regular"
                        sx={{ color: getApprovalStatusColor(row?.approval_status?.is_approved) }}>
                        {row?.approval_status?.is_approved ? "Approved" : "Not Approved"}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography
                        variant="body2Regular"
                        sx={{
                          color: getApprovalStatusColor(row?.approval_status?.is_second_approved)
                        }}>
                        {row?.approval_status?.is_second_approved ? "Approved" : "Not Approved"}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <MoreHorizIcon
                        sx={{ cursor: "pointer" }}
                        onClick={(e) => handleMenuClick(e, row)}
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </CustomTable>
        </TableContainer>
        {paginatedNotableVipsList?.length > 0 && (
          <Box className="d-flex justify-content-end mt-3">
            <AppPagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </Box>
        )}
      </Grid>
      <Backdrop
        sx={{ color: theme.palette.white.main, zIndex: 1300 }}
        open={openMenu}
        onClick={handleMenuClose}>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          PaperProps={{
            sx: {
              marginTop: "15px",
              backgroundColor: theme.palette.background.default,
              borderRadius: "12px",
              "& .MuiList-root": {
                backgroundColor: theme.palette.background.default,
                width: "225px",
                boxSizing: "border-box",
                padding: "10px 0"
              }
            }
          }}>
          {!selectedVip?.approval_status?.is_second_approved && (
            <StyledMenuItem onClick={() => handleApproveVip(selectedVip)}>
              <Typography variant="body1Regular">Approve for CMS</Typography>
            </StyledMenuItem>
          )}
          {!selectedVip?.approval_status?.is_approved && (
            <StyledMenuItem onClick={() => handleApproveVipCMS(selectedVip)}>
              <Typography variant="body1Regular">Approve for Mobile</Typography>
            </StyledMenuItem>
          )}
          <StyledMenuItem onClick={() => handleDeleteVip(selectedVip?.id)}>
            <Typography sx={{ color: theme.palette.red.main }} variant="body1Regular">
              Delete
            </Typography>
          </StyledMenuItem>
        </Menu>
      </Backdrop>
      <DeleteConfirmationDialog
        description={`Are you sure you want to delete ${selectedVip?.name ?? ""}?`}
        onClose={() => setDeleteModal(false)}
        onDelete={onConfirmDelete}
        open={deleteModal}
      />
      <AddMenuItems
        open={openMenuItemsModal}
        onClose={() => {
          setOpenMenuItemsModal(false)
          dispatch(marketingActions.setFoodItemsDetail({}))
          dispatch(marketingActions.setMenuCategoryId(""))
          dispatch(
            getNotableVipsAction({
              startDate: startDate || moment().format("YYYY-MM-DD"),
              endDate: endDate || moment().format("YYYY-MM-DD")
            })
          )
        }}
        isEdit={true}
      />
    </Grid>
  )
}

export default VipConfiguration
